import { render } from "./StoreButton.vue?vue&type=template&id=15bd6d00&scoped=true"
import script from "./StoreButton.vue?vue&type=script&lang=js"
export * from "./StoreButton.vue?vue&type=script&lang=js"

import "./StoreButton.vue?vue&type=style&index=0&id=15bd6d00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bd6d00"]])

export default __exports__